import { useEffect } from 'react';

const PIXEL_ID = '1808440502705240';

export default function FacebookPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);

      window.fbq = function() {
        window.fbq.callMethod
          ? window.fbq.callMethod.apply(window.fbq, arguments)
          : window.fbq.queue.push(arguments);
      };
      window.fbq.queue = [];
      window.fbq.loaded = true;
      window.fbq.version = '2.0';

      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    }
  }, []);

  return null;
}
